import React from "react";
import { Card } from "@UI/Components/Card/Card";
import { Text } from "@UI/Components/Text/Text";
import { Flex } from "@UI/Components/Flex/Flex";
import { Icon } from "@UI/Components/Icon/Icon";
import useMediaQuery from "@UI/hooks/useMediaQuery";
import { ArrowRight } from "@UI/Components/Icons/ArrowRight";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

export interface IImproveCard {
  type:
    | "share_profile"
    | "respect_rules"
    | "how_to_super"
    | "do_jobs"
    | "ask_questions"
    | "discover_advice";
  onClick?: (param: string) => void;
}

export const ImproveCard = ({ type, onClick }: IImproveCard) => {
  const { isMobile } = useMediaQuery();

  return (
    <Card
      w="full"
      p={{ base: 4, md: 4 }}
      onClick={() => onClick(type)}
      cursor="pointer"
      height="auto"
      role="group"
      _hover={{
        shadow: "lg",
      }}
    >
      <Flex justifyContent="space-between">
        <Flex mr={3} lineHeight="150%" overflow="hidden" wordBreak="break-word">
          <Text as="span" fontWeight={400} fontSize="16px" overflow="hidden">
            <FormattedMessage {...messages[type]} />
          </Text>
        </Flex>
        {!isMobile ? (
          <Flex alignItems="flex-end">
            <Flex w="max-content">
              <Text
                as="span"
                textDecoration="underline"
                _groupHover={{ color: "gray.800" }}
              >
                <FormattedMessage
                  {...messages.seeMore}
                  values={{
                    RightIcon: () => (
                      <Icon as={ArrowRight} w={4} h={4} fontWeight={700} />
                    ),
                  }}
                />
              </Text>
            </Flex>
          </Flex>
        ) : (
          <Flex alignItems="center">
            <Icon as={ArrowRight} w={4} h={4} fontWeight={700} />
          </Flex>
        )}
      </Flex>
    </Card>
  );
};
